export default __webpack_public_path__ + "static/media/IconDesc_NuclearPasta.256.c8ccf9ee.png";